import React from 'react';
import { Modal, Typography, Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

const DeleteConfirmationModal = ({ isOpen, onClose, onDelete, message }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          maxWidth: '400px',
          maxHeight: '300px',
          overflowY: 'auto',
          margin: 'auto',
          marginTop: '100px',
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Delete Confirmation
        </Typography>
        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="error" onClick={onDelete}>
            Delete
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default DeleteConfirmationModal;
